// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__18hDy","colCheckbox":"styles_colCheckbox__3hCtI"};